import { h } from 'preact';
import { usePlayerContext } from '../../../common/hooks';
import { connect, Delayed, withBreakPoints } from '../../hoc';
import SpinnerFranceTV from './spinner';

import { INTRO_TRANSITION_OUT, INTRO_WRAPPER_STYLES } from '../../../common/styles';
import { onFinishCreator } from '../../../common/utils/tools';

function Spinner({
  isIntro,
  waiting,
  width,
  height
}) {
  const player = usePlayerContext();
  if (!waiting && !isIntro) return null;

  return (
    <div style={{
      ...INTRO_WRAPPER_STYLES,
      width,
      height,
      ...(waiting || isIntro ? {} : INTRO_TRANSITION_OUT)
    }}
    >
      <Delayed
        isMounted={waiting}
        shouldDelay={isIntro}
        delay={2000}
        onFinish={onFinishCreator(player, isIntro)}
      >
        {(delayedState) => <SpinnerFranceTV {...delayedState} />}
      </Delayed>
    </div>
  );
}

const selector = ({
  ui: {
    waiting,
    isIntro,
    width,
    height
  }
}) => ({
  waiting,
  isIntro,
  width,
  height
});

export default withBreakPoints(connect(selector)(Spinner));
